import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiButton } from '@/components/ui/Button';
import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { useOnboarding } from '@/pages/Onboarding/context';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../../OwnAI/components/Title';
import { LayoutDataType } from '../../types';

import {
  ContentWrapperStyles,
  OverlayStyles,
  PageStyles,
} from './SendVideo.styles';

export const ScreenSendVideo: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'SendVideo',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();

  const handleSelect = (value: boolean) => {
    form.setValue('send_videos', value);
    userService.createOrUpdate({ onboarding_data: { send_videos: value } });
    wizard.nextStep();
  };

  return (
    <PageStyles
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-ons/send-video/bg.webp`}
    >
      <IonContent>
        <OverlayStyles />
        <ContentWrapperStyles>
          <OwnAiTitle>
            Do you want her
            <br />
            to send videos{' '}
            <span role="img" aria-label="video">
              📹
            </span>
            ?
          </OwnAiTitle>
          <UiButton
            size="large"
            onClick={() => handleSelect(true)}
            expand={'full'}
            round={'md'}
          >
            Yes
          </UiButton>
          <UiButton
            size="large"
            onClick={() => handleSelect(false)}
            expand={'full'}
            round={'md'}
            color={'transparent'}
          >
            No
          </UiButton>
        </ContentWrapperStyles>
      </IonContent>
    </PageStyles>
  );
};
